import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import moment from 'moment';
import InputDateTime from './inputDateTime';
import TimeSelect from './TimeSelect';

let InputRadioWithField = ({input, values, min, radioName, activeDate, label, option1, placeholder, meta: { touched, error } }) => {
  return (
    <div className="form-group mispari-border row">
      {touched && error && <div>
        <span className="text-danger">{error}</span></div>}
      <div className="col-md-7 font-weight-bold">
        <label>{label}</label>
      </div>
      <div className="col-md-5">
        <div className="custom-controls">
          <label className="custom-control  custom-radio">
              <input {...input} className="custom-control-input" type="radio" name={radioName} value="option1"/>
              <span className="custom-control-indicator"></span>
              <span className="custom-control-description">{option1}</span>
            </label>
            <label className="custom-control custom-radio col-sm-row">
              <input {...input} className="custom-control-input" type="radio" name={radioName} value="option2"/>
              <span className="custom-control-indicator custom-control-indicator-center"></span>
                <Field placeholder={placeholder} activeDate={activeDate} radioName={radioName} label="nom" className="form-control" values={values} component={InputDateTime} min={min} name={`${radioName}Field`} type="date" />
                <Field activeDate={activeDate} radioName={radioName} label="nom" className="form-control" component={TimeSelect} min={min} name={`${radioName}TimeField`} values={values[radioName]} type="time" />
            </label>
        </div>
      </div>
    </div>

  );
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    values: getFormValues('mispari')(state) ||{},
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

InputRadioWithField = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputRadioWithField);

export default InputRadioWithField;



// WEBPACK FOOTER //
// ./src/lib/forms/InputRadioWithField.js